import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../auth/auth.service';

@Component({
  selector: 'app-teklif-olusturuldu',
  templateUrl: './teklif-olusturuldu.component.html',
  styleUrls: ['./teklif-olusturuldu.component.css']
})
export class TeklifOlusturulduComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  teklifId: string = null;
  publicAccessKey: string = null;
  isAuthenticated = false;

  constructor(private route: ActivatedRoute,
              private authService: AuthService,
              private router: Router) {
  }

  ngOnInit(): void {
    this.isAuthenticated = this.authService.isLoggedIn();
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      // console.log(params);
      this.teklifId = params.id;
      this.publicAccessKey = params.key;
    }));
  }


  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  showDetails() {
    if (this.publicAccessKey != null) {
      this.router.navigate(['teklif'], {queryParams: {key: this.publicAccessKey}});
    } else if (this.teklifId != null) {
      this.router.navigate(['teklif'], {queryParams: {id: this.teklifId}});
    }
  }

  showTeklifler() {
    this.router.navigate(['teklifler']);
  }
}
